import classNames from "classnames";
import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@/components/Icon";
import { SELECT_ICONS } from "@/components/Select";
import { ITypeaheadProps as IEworkitTypeaheadProps, Typeahead as EworkitTypeahead } from "@/eworkitComponents";

import "./_typeahead.scss";

export interface ITypeaheadProps<T = any> extends IEworkitTypeaheadProps<T> {
  icon?: string;
  styles?: any;
}

const Typeahead: FC<ITypeaheadProps> = memo(({ isClearable = true, value, icon, size = "lg", ...props }) => {
  const { t } = useTranslation("common");

  const eworkitValue = value ? value : null;

  const baseClass = "typeahead";
  const rootClass = classNames(baseClass, {
    [`${baseClass}--with-icon`]: icon,
  });

  return (
    <div className={rootClass}>
      {icon && <Icon icon={icon} className={`${baseClass}__icon`} color="grey4" size={size} />}
      <EworkitTypeahead
        icons={SELECT_ICONS}
        isClearable={isClearable}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? t("MESSAGES.NO_RESULTS_FOUND") : t("MESSAGES.TYPE_TO_SEARCH")
        }
        value={eworkitValue}
        size={size}
        {...props}
      />
    </div>
  );
});

export { Typeahead };
